<template>
	<v-container
		class="fill-height"
		fluid
	>
		<v-row
			align="center"
			justify="center"
		>
			<v-col
				cols="12"
				sm="8"
				md="4"
			>
				<v-card class="elevation-12">
					<v-toolbar
						flat
					>
						<v-spacer></v-spacer>
						<v-toolbar-title>Login form</v-toolbar-title>
						<v-spacer></v-spacer>
					</v-toolbar>
					<v-card-text>
						<v-form @submit.prevent="authRequest" id="login-form">
							<v-text-field
								label="Login"
								name="login"
								:rules="emailRules"
								prepend-icon="mdi-account"
								type="text"
								v-model="user.email"
							></v-text-field>

							<v-text-field
								id="password"
								label="Password"
								name="password"
								:rules="passwordRules"
								prepend-icon="mdi-lock"
								type="password"
								v-model="user.password"
							></v-text-field>
							<v-alert
								dense
								outlined
								type="error"
								v-if="error"
							>
								{{ error }}
							</v-alert>
						</v-form>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn style="margin-bottom: 15px;" type="submit" color="primary" form="login-form">Login</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>

import {mapActions} from 'vuex'

export default {
		name: 'Home',
		data: () => ({
			emailRules: [
				v => !!v || 'E-mail is required',
				v => /.+@.+/.test(v) || 'E-mail must be valid',
			],
			passwordRules: [
				v => !!v || 'Password is required',
			],
			user: {
				email: '',
				password: ''
			},
			error: ''
		}),
		components: {

		},
		methods: {
			...mapActions('user', ['login']),
			authRequest() {
				let email = this.user.email
				let password = this.user.password

				this.login({email, password})
					.then(() => {
						this.$router.push('/')
					})
					.catch(err => {
						this.error = err.response.data.message
					})
			}
		}
	}

</script>
